module.exports = __webpack_public_path__ + "img/chevronleft.a859f774.png";